import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { Arbitro } from '../../system/Arbitro/Arbitro';
import { ArbitroSecundarioOfflineAssertions } from '../../system/PlanillaPartidoOffline/ArbitroSecundarioOfflineAssertions';

class ArbitroSecundarioOfflineForm extends CustomForm {
  protected constructor(
    arbso_id: string | null,
    arbso_tipo_doc: string,
    arbso_nro_doc: string,
    arbso_nombre: string,
    arbso_apellido: string
  ) {
    const arbsoff = ArbitroSecundarioOfflineAssertions.build();
    super('ArbitroSecundarioOffline', arbsoff);
    this.addInputAsserted('arbso_id', arbso_id);
    this.addInputAsserted('arbso_tipo_doc', arbso_tipo_doc);
    this.addInputAsserted('arbso_nro_doc', arbso_nro_doc);
    this.addInputAsserted('arbso_nombre', arbso_nombre);
    this.addInputAsserted('arbso_apellido', arbso_apellido);
  }

  private static build(
    arbso_id: string | null,
    arbso_tipo_doc: string,
    arbso_nro_doc: string,
    arbso_nombre: string,
    arbso_apellido: string
  ) {
    return new this(arbso_id, arbso_tipo_doc, arbso_nro_doc, arbso_nombre, arbso_apellido);
  }

  static initialize() {
    return this.build(null, '', '', '', '');
  }

  toArbitro(): Arbitro {
    return Arbitro.createFrom(
      this.getIdInput().getValue(),
      this.getNombreInput().getValue(),
      this.getApellidoInput().getValue(),
      this.getNroDocInput().getValue(),
      new Date(),
      '',
      '',
      '',
      '',
      0,
      '',
      '',
      '',
      true,
      0,
      '',
      [],
      [],
      [],
      this.getTipoDocInput().getValue()
    );
  }

  getIdInput() {
    return this.getInputByName('arbso_id');
  }

  getTipoDocInput() {
    return this.getInputByName('arbso_tipo_doc');
  }

  getNroDocInput() {
    return this.getInputByName('arbso_nro_doc');
  }

  getNombreInput() {
    return this.getInputByName('arbso_nombre');
  }

  getApellidoInput() {
    return this.getInputByName('arbso_apellido');
  }
}

export default ArbitroSecundarioOfflineForm;
